import { useModalAction } from '@/components/modal-views/context';
import { useMe } from '@/data/user';

export const useAuthAction = () => {
  const { me } = useMe();
  const { openModal } = useModalAction();

  const handleAuthAction = (action: () => void) => {
    if (!me) {
      openModal('REGISTER');
      return;
    }
    action();
  };

  return {
    handleAuthAction,
    isAuthenticated: !!me,
  };
};
